import React, { useEffect, useState } from 'react'
import {
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    DropdownToggle,
    Table,
    CardFooter,
    Pagination,
    PaginationItem,
    PaginationLink
} from "reactstrap";
import { useDispatch } from 'react-redux';
import { fetchWorkActivity, updateWorkActivityModal, editWorkActivity, deleteWorkActivity, deleteWorkActivityReset } from 'redux/WorkActivities/WorkActivitiesActions';
import Swal from 'sweetalert2'
import { connect } from 'react-redux';

const WorkActivitiesTable = (props) => {
    
    const dispatch = useDispatch();

    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);

  
    useEffect(() => {
        
        const data = {
            route : "",
            userId: props.userDetails.userId
        }
       
        dispatch(fetchWorkActivity(data))
        
        
    }, [])
    
    useEffect(() => {
        
        setList(props.fetchWorkActivities.workactivities.slice(0, 5))
        
        
    }, [props.fetchWorkActivities])
        
    
    if(props.deleteWorkActivity.workactivity.length && typeof props.deleteWorkActivity.error === "undefined"){
        
        Swal.fire({
            title: 'Deleted!',
            text: 'Successfully deleted Work/Activity!',
            icon : 'success',
            timer: 3000      
          }
        )
        dispatch(deleteWorkActivityReset());
        
        
      }

    else if(typeof props.deleteWorkActivity.error !== "undefined"){
        
        Swal.fire({
            title:'Failed!',
            text:'Failed to delete Work/Activity!',
            icon :'error',
            timer: 3000 
            }
        )            
        dispatch(deleteWorkActivityReset());
    }
    
    
    const onClickEditWorkActivity = (e,workactivityId) => {
        e.preventDefault();
        dispatch(editWorkActivity({
            status : true,
            workactivityId : workactivityId
        }));

        dispatch(updateWorkActivityModal(!props.updateWorkActivityModalStatus.status));
    }

    const onClickDeleteWorkActivity = (e,workactivityId) => {
        e.preventDefault();
        

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteWorkActivity({
                    docId : workactivityId,
                    userId : props.userDetails.userId
                }));

            }
          })
    }
    
    const showNext = (e,item) => {
        e.preventDefault();
        
        if(list.length !== 0) {
            dispatch(fetchWorkActivity({route:"Next" , item:item.item, userId: props.userDetails.userId}))
            setList(props.fetchWorkActivities.workactivities)
            setPage(page + 1)
        } 
    };

    const showPrevious = ( e,item ) => {
        e.preventDefault();
        if(list.length !== 0) {
            dispatch(fetchWorkActivity({route:"Previous", item:item.item, userId: props.userDetails.userId}))
            setList(props.fetchWorkActivities.workactivities)
            setPage(page - 1)
        } 
    };

    return (
    <>
        
        <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
                <tr>
                    
                    <th scope="col">EXPERIENCE NAME</th>
                    <th scope="col">EXPERIENCE TYPE</th>
                    <th scope="col">ORGANIZATION NAME</th>
                    <th scope="col">COUNTRY</th>
                    <th scope="col">CITY</th>
                    <th scope="col">ACTION</th>
                </tr>
            </thead>
            <tbody>
                
                
                {
                    list.map((val) => {
                                          
                    return <tr key = {val.workActivityId}>
                            <td scope="row">
                                {val.experienceName}
                            </td>
                            <td>
                                {val.experienceType}
                            </td>
                            <td>
                                {val.organizationName}
                            </td>
                            <td>
                                {val.country}
                            </td>
                            <td>
                                {val.city}
                            </td>
                            <td className="">

                                {/* {props.adminUser.admin ?
                                    <a  className="btn btn-sm btn-primary" onClick={(e) => onClickEditWorkActivity(e,val.workActivityId)}><i className="fa fa-eye"></i> View</a>
                                    :
                                    <>
                                        <a  className="btn btn-sm btn-primary" onClick={(e) => onClickEditWorkActivity(e,val.workActivityId)}><i className="fa fa-pen"></i> Edit</a>
                                        <a  className="btn btn-sm btn-danger" onClick={(e) => onClickDeleteWorkActivity(e,val.workActivityId)}><i className="fa fa-trash"></i> Delete</a>
                                    </>
                                } */}
                                {
                                    <>
                                        <a  className="btn btn-sm btn-primary" onClick={(e) => onClickEditWorkActivity(e,val.workActivityId)}><i className="fa fa-pen"></i> Edit</a>
                                        <a  className="btn btn-sm btn-danger" onClick={(e) => onClickDeleteWorkActivity(e,val.workActivityId)}><i className="fa fa-trash"></i> Delete</a>
                                    </>
                                }
                                {/* <UncontrolledDropdown>
                                <DropdownToggle
                                    className="btn-icon-only text-light"
                                    
                                    role="button"
                                    size="sm"
                                    color=""
                                    onClick={(e) => e.preventDefault()}
                                >
                                    <i className="fas fa-ellipsis-v" />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-arrow" right>
                                    <DropdownItem
                                    
                                    onClick={(e) => onClickEditWorkActivity(e,val.workActivityId)}
                                    >
                                    Edit
                                    </DropdownItem>
                                    <DropdownItem
                                    
                                    onClick={(e) => onClickDeleteWorkActivity(e,val.workActivityId)}
                                    >
                                    Delete
                                    </DropdownItem>
                                </DropdownMenu>
                                </UncontrolledDropdown> */}
                            </td>
                        </tr>
                    })

                }
                    
                    
                
            </tbody>
        </Table>
        <CardFooter className="py-4">
            <nav aria-label="...">
                <Pagination
                className="pagination justify-content-end mb-0"
                listClassName="justify-content-end mb-0"
                >
                <PaginationItem className={page === 1 ? 'disabled' : ''}>
                    <PaginationLink
                    
                    onClick={(e) => showPrevious(e,{ item: list[0] })}
                    tabIndex="-1"
                    >
                    <i className="fas fa-angle-left" />
                    <span className="sr-only">Previous</span>
                    </PaginationLink>
                </PaginationItem>
                {/* <PaginationItem className="active">
                    <PaginationLink
                    
                    onClick={(e) => e.preventDefault()}
                    >
                    1
                    </PaginationLink>
                </PaginationItem>
                <PaginationItem>
                    <PaginationLink
                    
                    onClick={(e) => e.preventDefault()}
                    >
                    2 <span className="sr-only">(current)</span>
                    </PaginationLink>
                </PaginationItem>
                <PaginationItem>
                    <PaginationLink
                    
                    onClick={(e) => e.preventDefault()}
                    >
                    3
                    </PaginationLink>
                </PaginationItem> */}
                <PaginationItem className={list.length < 5 ? 'disabled' : ''}>
                    <PaginationLink
                    
                    onClick={(e) => showNext(e,{ item: list[list.length - 1] })}
                    >
                    <i className="fas fa-angle-right" />
                    <span className="sr-only">Next</span>
                    </PaginationLink>
                </PaginationItem>
                </Pagination>
            </nav>
        </CardFooter>
    </>
  )
}
const mapStateToProps = state => {
    return {
        fetchWorkActivities : state.fetchWorkActivities,
        updateWorkActivityModalStatus : state.updateWorkActivityModalStatus,
        deleteWorkActivity : state.deleteWorkActivity,
        userDetails : state.loginAuth.userDetails,
        adminUser : state.adminUser
    }
  }


export default connect(mapStateToProps)(WorkActivitiesTable)